import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import { http_get, http_post } from "./api/api";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.$http_get = http_get;
Vue.prototype.$http_post = http_post;
// 复制文本到剪贴板
Vue.prototype.$copy = (text) => {
  const value = String(text ?? "");
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(value);
  }
  const textarea = document.createElement("textarea");
  textarea.value = value;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "absolute";
  textarea.style.left = "-9999px";
  document.body.appendChild(textarea);
  textarea.select();
  textarea.setSelectionRange(0, textarea.value.length);
  const ok = document.execCommand("copy");
  document.body.removeChild(textarea);
  return ok ? Promise.resolve() : Promise.reject(new Error("copy failed"));
};

new Vue({
  router,
  render: (h) => h(App)
}).$mount("#app");
